import { render, staticRenderFns } from "./DisplayStories.vue?vue&type=template&id=24a058fe"
import script from "./DisplayStories.vue?vue&type=script&lang=ts"
export * from "./DisplayStories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports